import { Pipe, PipeTransform } from '@angular/core';
import moment from "moment";
@Pipe({
    name: 'displayMomentDate',
    standalone: false
})
export class DisplayMomentDatePipe implements PipeTransform {

  transform(value: any): unknown {
    let momentObj = moment(value)
    if(momentObj.isValid()){
      const dateStr = momentObj.toString()
      return dateStr
    } else {
      return null
    }
  }

} 
